const initialState = {
  status: ''
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HTTP_ERROR': {
      const newState = { ...state, ...action.payload };
      return newState;
    }
    default:
      return state;
  }
};

export default errorReducer;
